export const AVAILABLE_LANGS = [
  { code: "pl", label: "PL" },
  { code: "en", label: "EN" },
  { code: "uk", label: "UA" },
  { code: "de", label: "DE" },
  { code: "it", label: "IT" },
  { code: "sk", label: "SK" },
  { code: "es", label: "ES" },
  { code: "fr", label: "FR" },
];
export function normalizeLang(raw) {
  if (!raw) return "pl";
  const lower = raw.toLowerCase();
  const base = lower.split("-")[0];
  return AVAILABLE_LANGS.find((l) => l.code === base) ? base : "pl";
}
